export default __webpack_public_path__ + "static/media/hashtag.e03b064f.svg";